import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/service-role";

export const getAllServiceRole = () => axios.get(API_PATH + "/get-all")

export const pagingServiceRole = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const saveOrUpdateServiceRole = serviceRole => axios.post(API_PATH + "/save", serviceRole);

export const getServiceRoleById = (serviceRoleId) => axios.get(API_PATH + "/get-by-id/" + serviceRoleId);

export const deleteServiceRole = serviceRoleId => axios.delete(API_PATH + '/mark-delete/' + serviceRoleId);
